import { TabNode } from "flexlayout-react";
import { useGrid } from "@/hooks/useGrid.ts";
import { useDashboard } from "@/lib/store.ts";
import { EWidgetType } from "@/domain/enums/dashboard.enum.ts";
import { FavoriteStar } from "@/components/shared/favoriteStar.tsx";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useCallback } from "react";

export function PinInTabHeader({ node }: { node: TabNode }) {
  const { getNodeConfig } = useGrid(node.getId());
  const { colorsToSymbolMap, pinned, updatePinned } = useDashboard((state) => ({
    colorsToSymbolMap: state.colorsToSymbolMap,
    pinned: state.pinned,
    updatePinned: state.updatePinned,
  }));
  const config = getNodeConfig();
  const symbol = colorsToSymbolMap?.[config.color];

  const togglePin = useCallback(
    (symbol: string) => {
      updatePinned((state) => {
        if (state.includes(symbol)) {
          return state.filter((s) => s !== symbol);
        }
        return [...state, symbol];
      });
    },
    [updatePinned],
  );

  if (node.getComponent() === EWidgetType.chart) {
    return (
      <Button
        type="button"
        variant="ghost"
        size="xxs"
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          togglePin(symbol);
        }}
        className="pointer-events-auto pl-2 h-auto text-xs hover:bg-transparent"
      >
        <i
          className={cn(
            pinned?.includes(symbol)
              ? "fa-solid fa-thumbtack"
              : "fa-regular fa-thumbtack text-gray-400 transform rotate-45",
          )}
        />
      </Button>
    );
  }
  return null;
}
